module.exports = __webpack_public_path__ + "img/vase.834d4bf3.jpg";